export default ({} = {}) => {
  console.log("init cookies notice");

  if (
    !localStorage.getItem("cookies") &&
    document.querySelector(".m_cookies")
  ) {
    document.querySelector(".m_cookies").style.display = "flex";
    document
      .querySelectorAll(".m_cookies--close, .m_cookies--content a")
      .forEach((btn) => {
        btn.addEventListener("click", () => {
          document.querySelector(".m_cookies").style.display = "none";
          localStorage.setItem("cookies", "read");
        });
      });
  }

  return {};
};
